import React from 'react';
import { useSelector } from "react-redux";
import TargetHandle from '../TargetHandle';
import SourceHandle from '../SourceHandle';
import { Chip, Divider, Tooltip } from '@mui/material';
import CommonNode from './CommonNode';
import { OPTIONS_TO_DISPLAY } from '../constant';

function OptionsNode({ data, icon }) {

  const lang = useSelector(state => state.lang.ui.lang);

  const showMoreChip = data?.answerOptionList?.length > OPTIONS_TO_DISPLAY
  const moreCount = data?.answerOptionList?.length - OPTIONS_TO_DISPLAY
  const first3Options = data?.answerOptionList?.slice(0, OPTIONS_TO_DISPLAY)

  return (
    <div className={`callflow-node start-node ${data?.status == 'D' && 'disabled-node'}`} style={{ display: 'flex' }}>
      <CommonNode disableSourceHandle disableTargetHandle disableStyle data={data} icon={icon} />
      <TargetHandle id={data?.id} />
      {
        data?.answerOptionList
        && (
          <>
            <Divider sx={{ mx: 2 }} orientation="vertical" flexItem />
            <div>
            {
              first3Options?.map((op, idx) => (
                <div className='option' key={op?.key}>
                  <Tooltip title={
                    <div>
                      {Object.entries(op?.value).map(([key, value]) => (<div key={key}>{key}: {value}</div>))}
                    </div>
                  }>
                    <div className='text'>{op?.value?.[lang]}</div>
                  </Tooltip>
                  <SourceHandle key={op?.key} id={op?.key} styles={{ visibility: data?.optionsNode ? 'visible' : 'hidden' }} />
                </div>
              ))
            }
            {showMoreChip && <Chip label={`+ ${moreCount}`} />}
            </div>
          </>
        )
      }
      <SourceHandle id={data?.id} styles={{ visibility: data?.optionsNode ? 'hidden' : 'visible' }} />
    </div>
  );
};

export default OptionsNode